import React, { useEffect, useRef, useState } from 'react';
import { Col, Row, Button, Table, Container, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { AiFillDelete } from 'react-icons/ai';
import { AiFillEdit } from 'react-icons/ai';
import { FcViewDetails } from 'react-icons/fc';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import Pagination from 'react-bootstrap/Pagination';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import AwardedDetailModal from '../Modals/AwardedPointModals/AwardedDetailModal';
import AwardedDelModal from '../Modals/AwardedPointModals/AwardedDelModal';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import _, { orderBy } from 'lodash';
import { toast } from 'react-toastify';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
import useQueryParamsPage from '../../hooks/useQueryParamsPage';
const AwardedPoints = () => {
    const { getToken, user } = useAuth();
    const [awardedPoints, setAwardedPoints] = useState();
    const [activeNumber, setActiveNumber] = useState(1);
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [paginationBtns, setPaginationBtns] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [allUnits, setAllUnits] = useState('');
    const { searchParams, page, updateQueryParams, setPage } = useQueryParamsPage();
    const navigate = useNavigate();

    useEffect(() => {
        getMeasuredUnits();
    }, []);
    useEffect(() => {
        getAllAwardedPoints();
    }, [page]);

    const handleClose = () => {
        setShowDelModal(false);
        setShowEditModal(false);
        setShowDetailModal(false);
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Transit Agency Name</span>
                </h6>
            ),
            selector: (row) => row?.transit_agency?.name || 'N/A',
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Route Name</span>
                </h6>
            ),
            selector: (row) => row?.route?.name || 'N/A',
            sortable: true,
            center: true
        },
        ...(user.role !== 'commuter'
            ? [
                  {
                      name: (
                          <h6 className="text-capitalize mt-2 text-center">
                              <span className="fw-bold">Commuter Name</span>
                          </h6>
                      ),
                      selector: (row) => row?.commuter?.name || 'N/A',
                      sortable: true,
                      center: true
                  }
              ]
            : []),
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    GHG Saved <span className="unit-text text-lowercase">{allUnits?.GHG_unit ? `(${allUnits?.GHG_unit})` : ''}</span>
                </h6>
            ),
            selector: (row) => row.ghg_saved,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Points Awarded</span>
                </h6>
            ),
            selector: (row) => row.points_earned,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Time stamp</span>
                </h6>
            ),
            selector: (item) => (
                <div className="text-center">
                    <span>{item?.date ? moment(item?.date).format('MM-DD-YYYY') : ''}</span>
                    <br />
                    <span>{item?.finished_at ? moment(item?.finished_at, 'hh:mm').format('hh:mm:A') : ''}</span>
                </div>
            ),
            sortable: true,
            center: true
        },

        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('awarded-points-details', {
                                            state: {
                                                awardPoint_id: row._id,
                                                awardPointDetails: row
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    {user.role !== 'commuter' && (
                        <div className="del-detail">
                            <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                                <div className="edit-detail">
                                    <img
                                        width={15}
                                        className="me-3"
                                        src={delIcon}
                                        alt=""
                                        onClick={() => {
                                            setShowDelModal(true);
                                            setSelectedItem(row);
                                        }}
                                    />
                                </div>
                            </OverlayTrigger>
                        </div>
                    )}
                </div>
            ),
            center: true
            // sortable: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };
    const getMeasuredUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token && selectedItem?._id) {
            new WebApiCalls()
                .deleteAwardedPoints(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Awarded Points has been deleted successfully.');
                        getAllAwardedPoints();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    const getAllAwardedPoints = async (pageSize = 10, pageNo = 0, _search) => {
        const authToken = getToken();

        if (authToken) {
            setLoading(true);
            let allAwardedPoints = await new WebApiCalls().getAllAwardsPoints(authToken, pageSize, page, _search);
            // console.log('Result of getAllAwardedPoints:    ', allAwardedPoints);
            setAwardedPoints(allAwardedPoints?.data?.awardedPoints);
            setTotalRecords(allAwardedPoints?.data?.totalCount);
            // calcPagination(allAwardedPoints?.data?.totalCount);
            setLoading(false);
        }
    };

    const handlePageChange = (pageNo) => {
        setPage(pageNo);
        updateQueryParams({ page: pageNo });
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllAwardedPoints(pageSize, pageNo);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllAwardedPoints(undefined, undefined, text);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkRewards(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllAwardedPoints();
                            setLoading(false);
                            toast.success('Rewards are Updated Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkAwardedPoints(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllAwardedPoints();
                            setLoading(false);
                            toast.success('Awarded Points are Delete Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };
    const customSort = (rows, selector, direction) => {
        return orderBy(rows, selector, direction);
    };

    return (
        <div style={{ padding: '20px' }}>
            <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                <Modal.Title className="text-center">
                    <h6 className="text-capitalize mt-2">
                        <span className=" breadcrumb-heading">Change Status</span>
                    </h6>
                    {/* Routes */}
                    <hr></hr>
                </Modal.Title>
                <Modal.Body className="text-center">
                    {/* <div className="icon-warning-wrapper my-1 mt-1"><img src={warningIcon} alt="" /></div> */}
                    <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                    <div className="text-content-wrapper mt-3">
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#198754' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('active');
                                }}
                            >
                                Active
                            </Button>
                        </div>
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#F32013' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('inactive');
                                }}
                            >
                                Inactive
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 mt-2"></Modal.Footer>
            </Modal>

            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Awarded point?'} />
            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start">
                        <h6 className="text-capitalize mt-2 text-center">
                            {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                        Filter By
                    </span> */}
                        </h6>
                        {/* <select
                    onChange={(e) => {
                        getAllVendors(undefined, undefined, e.target.value);
                        setIsTypeFilterSelected(e.target.value ? true : false);
                    }}
                    className="status-selector w-120"
                    aria-label="Default select example"
                    style={{ color: !isTypeFilterSelected ? '#9a9a9a' : '' }}
                >
                    <option value={''}>Transit Type</option>
                    <option value={'bus'}>Bus</option>
                    <option value={'streetcar'}>Street Car</option>
                    <option value={'subway'}>Subway</option>
                    <option value={'train'}>Train</option>
                </select> */}
                        {/* <select
                            onChange={(e) => {
                                getAllAwardedPoints(undefined, undefined, e.target.value, '');
                                setIsFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Status</option>
                            <option value={'active'}>Active</option>
                            <option value={'inactive'}>In Active</option>
                        </select> */}
                    </div>
                </Col>
                <Col sm={5} md={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                {/* <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: '#F3D119', color: 'black' }}
                                    onClick={(e) => {
                                        // updateBulk('active');
                                        setChangeStatusModal(true);
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Change Status
                                    {/* {activeButton} 
                                </Button> */}
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                        {/* <Button
                            className="add-record-btn justify-content-center  w-140"
                            style={{ background: '#13aa61' }}
                            onClick={(e) => {
                                // setActionType('add');
                                // setShowAddEditModal(true);
                            }}
                        >
                            Add
                        </Button> */}
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>

            <DataTable
                columns={columns}
                data={awardedPoints}
                selectableRows={user.role !== 'commuter' ? true : false}
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                paginationDefaultPage={parseInt(searchParams.get('page')) || 1}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={awardedPoints && awardedPoints?.length >= 0 ? false : true}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                sortFunction={customSort}

                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default AwardedPoints;
